<script>
import {useToast} from "vue-toastification";
import AssetMaterialSelectDialog from "@/AssetMaterialSelectDialog.vue";
import assetMaterialsHelper from "@/mixins/assetMaterialsHelper";

export default {
  components: {
    AssetMaterialSelectDialog
  },
  mixins: [
    assetMaterialsHelper
  ],
  props: [
      'client_id',
      'drupal_input_id', // The ID of hidden input element where we will add all ID's of selected material(s)
      'material_types', // Comma seperated list of material types we want to select
      'material_cardinality', // Can be '-1' for unlimited materials or, for example '1' if you only want to select one material
      'material_empty_text', // Shown when the no materials are selected
  ],
  async mounted() {
    // Setup toast
    this.toast = useToast()
    // Get CSRF token
    await this.requestGetCSRFtoken();
    // Get asset types
    await this.getAssetTypes('ovl');
    // Check if drupal_input_id already has a value
    const element = this.drupalInputElement();
    if (element.value) {
      // Split string values into a array
      const ids = element.value.split(",");
      // Load all materials
      for (const id of ids) {
        // Load the material from the server
        let material = await this.requestLoadDatabase(id);
        // Add material to the materials list
        this.addMaterial(material);
      }
    }
  },
  data () {
    return {
      toast: null,
      materials: [],
      selectMaterialDialog: false,
      selectMaterialAssetType: '', // For example: 'ovl_pole' or 'ovl_lamp'
      selectMaterialTheMaterialToBeReplaced: null,
    }
  },
  computed: {
    assetTypesFiltered() {
      // Only include the 'material_types' if set
      if (this.material_types.length > 0) {
        let asset_types_filtered = {};
        const material_types = this.material_types.split(',');
        // Only include the material types
        for (const material_type of material_types) {
          // Add material to the filtered list
          asset_types_filtered[material_type] = this.assetTypes[material_type];
        }
        return asset_types_filtered;
      }
      else {
        // #no-filter, return them all
       return this.assetTypes;
      }
    }
  },
  watch: {
    materials: {
      handler(newValue, oldValue) {
        const element = this.drupalInputElement();
        // Get all ID's
        const ids = [];
        for (const material of newValue) {
          ids.push(material.id);
        }
        // Create string from all ID's
        const ids_joined = ids.join(',');
        // Set value in the Drupal DOM input element
        element.value = ids_joined;
      },
      deep: true
    },
  },
  methods: {
    openMaterialDialog(assetType) {
      this.selectMaterialDialog = true;
      this.selectMaterialAssetType = assetType;
    },
    closeMaterialDialog() {
      this.selectMaterialDialog = false;
      this.selectMaterialAssetType = '';
    },
    materialSelected(selected_material) {
      const material = selected_material.selected_material;
      // Set the material type
      material.type = this.selectMaterialAssetType;
      // Add the material
      this.addMaterial(material);
      // Close the dialog
      this.closeMaterialDialog();
    },
    addMaterial(material) {
      this.materials.push(material);
    },
    removeMaterial(index) {
      this.materials.splice(index, 1)
    },
    getMaterialIndex(material) {
      // Get the index of the material
      return this.materials.findIndex(item => item.id === material.id);
    },
    drupalInputElement() {
      // Get the Drupal DOM input element
      const element_id = "#"+this.drupal_input_id;
      const element = document.querySelector(element_id);
      return element;
    },
    async requestLoadDatabase(id) {
      // Replace material by other material
      const response = await fetch(import.meta.env.VITE_API_BASEURL + 'api/database/' + id, {
        credentials: "include",
        headers: this.requestHeaders,
      })
      let database = await response.json();
      return database;
    }
  },
}
</script>


<template>

  <v-table v-if="materials.length" class="materials-table">
    <thead>
    <tr>
      <th class="text-left">
        Naam
      </th>
      <th class="text-left">
        Type
      </th>
    </tr>
    </thead>
    <tbody>
    <tr
      v-for="(material, index) in materials"
      :key="material.id"
    >
      <td>{{ material.label }}</td>
      <td>{{ assetTypesFiltered[material.type] }}</td>
      <td>
        <v-btn
          color="error"
          @click="removeMaterial(index)"
        >
          Verwijder
        </v-btn>
      </td>
    </tr>
    </tbody>
  </v-table>
  <p v-else>
    {{ material_empty_text }}
  </p>

  <v-btn
    color="primary"
    class="mt-2"
    v-if="materials.length < material_cardinality || material_cardinality === -1"
  >
    Selecteer materiaal <v-icon>mdi-menu-down</v-icon>

    <v-menu activator="parent">
      <v-list>
        <v-list-item
          v-for="(item, key) in assetTypesFiltered"
          :key="key"
          :value="key"
        >
          <v-list-item-title @click="openMaterialDialog(key)">
            {{ item }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-btn>

  <!-- Select material dialog -->
  <asset-material-select-dialog
    :client-id="client_id"
    :asset-type="selectMaterialAssetType"
    v-model="selectMaterialDialog"
    @material-selected="materialSelected"
    @dialog-closed="closeMaterialDialog"
  ></asset-material-select-dialog>


</template>

<style lang="scss">
  .materials-table {
    table {
      margin: 0;
    }
  }
</style>
